import { Organisation } from './../../Models/organisation';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { StringUpdater } from 'src/app/Helpers/updaters';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrgService {

  apiUrl: string;

  constructor(
    private httpclient: HttpClient
  ) {
      this.apiUrl = environment.apiUrl;
  }

  getOrganisations(page: number, size: number, org: string): Observable<any> {
    const url = this.apiUrl + '/api/organisation/' + page + '/' + size + '/' + org
     + '/';
    return this.httpclient.get<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  postOrganisation(org: Organisation): Observable<any> {
    return this.httpclient.post(this.apiUrl + '/api/organisation', org)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  putOrganisation(value: StringUpdater): Observable<any> {
    return this.httpclient.put(this.apiUrl + '/api/organisation/' + value.Id, value)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  deleteOrganisation(value: string): Observable<any> {
    return this.httpclient.delete(this.apiUrl + '/api/organisation/' + value)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  private handleError(error: any): any {
    throw error;
    return error;
  }

}
